<template>
  <div class="suggestions-carousel">
    <h5 class="text-color-navy suggestions-carousel__title text-h6" v-html="title" />
    <div class="suggestions-carousel__container">
      <div class="carousel">
        <div class="carousel__item">
          <swiper v-bind="swiperOptions">
            <swiper-slide
              v-for="(item, n) in items"
              :key="`${item.title}-1${n}`"
              class="carousel__slider-item"
            >
              <product-item :item="item" @itemClicked="$emit('itemClicked')" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue'

import ProductItem from '@/components/common/ProductItem.vue'

export default {
  name: 'SuggestionsCarousel',
  components: {
    Swiper,
    SwiperSlide,
    ProductItem,
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
  },
  emits: ['itemClicked'],
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        breakpoints: {
          415: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          667: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1179: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      },
    }
  },
}
</script>
